import React, { useContext, useEffect, useState, createContext, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { doToggleSidebar } from 'Store/actions/internalstore'

const ListenerContext = createContext()

export const ListenerProvider = ({ children }) => {
  // const [keyboard, setKeyboard] = useState(null)
  const expanded = useSelector((state) => state?.store?.sidebar?.expanded)
  const dispatch = useDispatch()

  const [mobileDetect, setMobileDetect] = useState({
    isMediumScreen: window.innerWidth <= 925,
    isSmallScreen: window.innerWidth <= 899,
    isMobile: window.innerWidth <= 768,
    isExtraSmallScreen: window.innerWidth <= 599,
    isTablet: window.innerWidth > 480 && window.innerWidth <= 768,
    isPhone: window.innerWidth <= 480,
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
    orientation: window.innerWidth < window.innerHeight ? 'PORTRAIT' : 'LANDSCAPE'
  })

  const handleResize = useCallback(() => {
    setMobileDetect({
      isMediumScreen: window.innerWidth <= 925,
      isSmallScreen: window.innerWidth <= 899,
      isMobile: window.innerWidth <= 768,
      isExtraSmallScreen: window.innerWidth <= 599,
      isTablet: window.innerWidth > 480 && window.innerWidth <= 768,
      isPhone: window.innerWidth <= 480,
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      orientation: window.innerWidth < window.innerHeight ? 'PORTRAIT' : 'LANDSCAPE'
    })
  }, [])

  useEffect(() => {
    let debounceTimer
    const debouncedResize = () => {
      clearTimeout(debounceTimer)
      debounceTimer = setTimeout(handleResize, 150)
    }
    window.addEventListener('resize', debouncedResize)
    return () => {
      clearTimeout(debounceTimer)
      window.removeEventListener('resize', debouncedResize)
    }
  }, [handleResize])

  const toggleSidebar = () => {
    dispatch(doToggleSidebar(!expanded))
  }

  return (
    <ListenerContext.Provider value={{ /*keyboard,*/ mobileDetect, expanded, toggleSidebar }}>
      {children}
    </ListenerContext.Provider>
  )
}

ListenerProvider.propTypes = {
  children: PropTypes.node.isRequired
}

// KEYBOARD HOOK
// export const useKeyboardListener = (callback) => {
//   const context = useContext(ListenerContext)

//   useEffect(() => {
//     if (callback && context.keyboard && context.keyboard.key) callback(context.keyboard.key)
//   }, [context.keyboard])

//   return context.keyboard && context.keyboard.key
// }

// MOBILE DETECT HOOK
export const useMobileDetect = () => {
  const context = useContext(ListenerContext)
  return context.mobileDetect
}

// SIDEBAR HOOK
export const useHandleSideBar = () => {
  const context = useContext(ListenerContext)
  return context
}
